// @angular
import {
  Component,
  OnDestroy,
  OnInit,
  effect,
  untracked,
  ChangeDetectionStrategy
} from "@angular/core";
// Own services
import { SessionDataService } from "../../../services/shared/SessionDataService.service";
import { ReloadComponentService } from "../../../services/shared/ReloadComponentService.service";
import { SubscriberCupsComponent } from "../subscriber-cups/subscriber-cups.component";

/**
 * Subscriber landing view: mirrors the session's subscriber CUPS list and selected CUPS data
 * and passes them to the CUPS detail component.
 */
@Component({
  selector: "app-cupsmain",
  templateUrl: "./subscriber-main.component.html",
  styleUrls: ["./subscriber-main.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubscriberCupsComponent]
})
export class SubscriberMainComponent implements OnInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  // Session variables
  currentSubscriberCupsList: any;
  currentSubscriberCupsData: any;
  sessionLanguage: string;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(
    private readonly ReloadComponentService: ReloadComponentService,
    private readonly SessionDataService: SessionDataService
  ) {
    effect(() => {
      const list = this.SessionDataService.subscriberCupsList();
      if (list !== null) {
        this.currentSubscriberCupsList = list;
      }
    });
    effect(() => {
      const data = this.SessionDataService.subscriberCupsData();
      if (data !== null) {
        this.currentSubscriberCupsData = data;
      }
    });
    effect(() => {
      const language = this.SessionDataService.language();
      if (language) {
        this.sessionLanguage = language;
      }
    });
  }

  /***************************************************************************/
  // ANCHOR Component initialization
  /***************************************************************************/

  ngOnInit(): void {
    // Load initial values
    this.currentSubscriberCupsList = untracked(() => this.SessionDataService.subscriberCupsList());
    this.currentSubscriberCupsData = untracked(() => this.SessionDataService.subscriberCupsData());
  }
}
